/* eslint-disable */
import Backbone from 'backbone';
import RequestContext from '@component/common/src/util/RequestContext';
import '@feature/quick-bag';
// import '@feature/quick-bag/src/scss/quick-bag/main.scss';
import LazyLoad from '@core/util/lazyload';
import App from './app';
import './src/scss/mcom/main.scss';

App.brand = 'mcom';

App.isMEW = RequestContext.getDeviceType().toLowerCase() === 'phone';
App.isTablet = RequestContext.getDeviceType().toLowerCase() === 'tablet';
App.teamName = $('script[data-bootstrap="page/cwgl"]').html() ? JSON.parse($('script[data-bootstrap="page/cwgl"]').html()).team : {};

function callback() {
  App.channel.trigger('LazyLoad::ready');
}

App.on('start', () => {
  // lazy loading
  const lazyLoad = new LazyLoad({
    // this was changed between versions
    // TODO CLI 2: remove callback_load
    callback_load: callback,
    callback_loaded: callback,
  });
  lazyLoad.ready.then(() => {
    // console.log('lazy loading is ready..');
  });

  if (Backbone.history && App.meta && App.meta.quickview) {
      import(/* webpackChunkName: 'qv-mcom' */ './src/js/mcom/quick-view-loader');
  }
});

export default App;
